<template>
    <div>
        Глобальный компонент
        <div v-show="is_test_show">Works</div>
    </div>
</template>

<script>
export default {
    name: 'Global Test',
    data() {
        return {
            is_test_show: false
        }
    },
    methods: {
        to_true() {
            this.is_test_show = true
        }
    }
}
</script>